export const translations = {
  en: {
    // Wizard (onboarding)
    restaurantSetup: "Restaurant Setup",
    setupDescription: "Let's get your kitchen organised — it only takes a few minutes.",
    stepOf: "Step {current} of {total}",
    back: "Back",
    next: "Next",
    completeSetup: "Complete Setup",
    startOver: "Start Over",
    allSet: "All Set!",
    allSetDescription: "Your kitchen structure, menu, and supplier information has been recorded. We'll use this to set up your workspace.",
    onboardingComplete: "Onboarding complete!",
    onboardingCompleteDesc: "Your kitchen structure has been saved.",

    // Step labels (onboarding)
    stepLabels: ["Kitchen Areas", "Dishes", "Components", "Ingredients", "Units", "Suppliers", "Final"],

    // Kitchen Areas (onboarding)
    kitchenAreasTitle: "What areas does your kitchen have?",
    kitchenAreasDesc: "Think of the different stations where food is prepared — for example Hot kitchen, Cold kitchen, Grill, Pastry, or Bar.",
    kitchenAreaPlaceholder: "e.g. Hot kitchen",
    addArea: "Add Area",

    // Dishes (onboarding)
    dishesTitle: "Which dishes are prepared in each area?",
    dishesDesc: "Add the dishes that belong to each kitchen area.",
    addDishTo: "Add a dish to {name}…",
    addDish: "Add Dish",

    // Components (onboarding)
    componentsTitle: "What goes into each dish?",
    componentsDesc: "Add the components that make up each dish — things like sauces, sides, or proteins.",
    componentPlaceholder: "e.g. Sauce, Side dish, Protein…",
    addComponent: "Add Component",

    // Ingredients (onboarding)
    ingredientsTitle: "What ingredients go into each component?",
    ingredientsDesc: "If a component is used in multiple dishes, you only need to list its ingredients once.",
    ingredientPlaceholder: "e.g. Oil, Garlic, Salt…",
    addIngredient: "Add Ingredient",

    // Units (onboarding)
    unitsTitle: "What units do you order in?",
    unitsDesc: "Pick the units you use when ordering ingredients, or add your own.",
    tapToAdd: "Tap to add common units:",
    customUnitPlaceholder: "Add a custom unit…",
    addUnit: "Add Unit",

    // Suppliers (onboarding)
    suppliersTitle: "Who are your suppliers?",
    suppliersDesc: "Add the suppliers you order ingredients from.",
    supplierNamePlaceholder: "Supplier name",
    supplierEmailPlaceholder: "Email address (optional)",
    addSupplier: "Add Supplier",

    // Final (onboarding)
    finalTitle: "Anything else we should know?",
    finalDesc: "This is optional — feel free to share any extra details about your kitchen, menu, or how you work.",
    finalPlaceholder: "e.g. We change our menu seasonally, we have shared prep areas, we need gluten-free options…",

    // ── Menu Editor ──
    createYourMenu: "Create Your Menu",
    menuStepLabels: ["Categories", "Dishes", "Components", "Ingredients", "Suppliers"],
    preview: "Preview",
    logOut: "Log out",
    save: "Save",
    saved: "✓ Saved",
    publish: "Publish",
    previewButton: "Preview",

    // Kitchen stations
    cold_kitchen: "Cold Kitchen",
    hot_kitchen: "Hot Kitchen",

    // StepCategories
    menuCategories: "Menu Categories",
    categoriesHelperText: "Add categories like Starters, Main Courses, Desserts",
    addCategory: "Add Category",
    noCategoriesYet: "No categories yet",
    noCategoriesHint: "Start by adding your first menu category above",
    categoryAdded: "Category added and saved",
    categoryRemoved: "Category removed",
    categoryRenamed: "Category renamed",
    categoryPlaceholder: "e.g. Main Courses",

    // StepDishes
    yourDishes: "Your Dishes",
    dishesHelperText: "Add dishes to each category and assign a kitchen station",
    addDishButton: "Add Dish",
    kitchenStation: "Kitchen Station",
    selectStation: "Select station",
    customStation: "Custom…",
    typeCustomStation: "Type custom station name",
    dishName: "Dish name",
    noDishesInCategory: "No dishes yet in this category",
    noCategoriesGoBack: "Go back to Step 1 to add categories first",
    dishAdded: "Dish added and saved",
    dishRemoved: "Dish removed",
    cancel: "Cancel",
    addDishTo2: "Add Dish to {name}",
    kitchen: "Kitchen",

    // StepComponents
    dishComponents: "Dish Components",
    componentsHelperText: "Break each dish into its building blocks — components are reusable across dishes",
    addComponentButton: "Add Component",
    newComponentName: "New component name...",
    orSelectExisting: "Or select existing:",
    searchComponents: "Search components...",
    alreadyAdded: "already added",
    done: "Done",
    noComponentsYet: "No components yet",
    noComponentsHint: "Go back to Step 2 to add dishes first",
    noDishesGoBack: "Go back to Step 2 to add dishes first",
    componentAdded: "Component added and saved",
    componentCreated: "Component created and saved",
    componentRemoved: "Component removed from dish",
    failedRemoveComponent: "Failed to remove component from dish",
    addComponentTo: "Add Component to {name}",

    // StepIngredients
    ingredientsTitleEditor: "Ingredients",
    ingredientsHelperText: "Define what goes into each component",
    addIngredientPlaceholder: "Add ingredient...",
    add: "Add",
    quickAddPlaceholder: "Quick add: paste multiple ingredients separated by commas or new lines (e.g. salt, olive oil, garlic)",
    quickAddAll: "Quick Add All",
    ingredientAdded: "Ingredient added and saved",
    ingredientsAdded: "{count} ingredient(s) added and saved",
    ingredientRemoved: "Ingredient removed",
    noComponentsGoBack: "Go back to Step 3 to add components to your dishes first",
    usedIn: "Used in",
    noIngredientsAddedYet: "No ingredients added yet",
    changeStation: "Change",

    // StepSuppliers
    suppliersTitleEditor: "Suppliers",
    suppliersHelperText: "Link suppliers to each ingredient",
    newSupplier: "New Supplier",
    selectSupplier: "Select supplier",
    copyPrevious: "Copy previous",
    notes: "Notes",
    optionalNotes: "Optional notes",
    supplierName: "Supplier Name *",
    emailRequired: "Email *",
    emailOptional: "Email (optional)",
    createSupplierButton: "Create Supplier",
    supplierCreated: "Supplier created and saved",
    supplierLinked: "Supplier linked and saved",
    noPreviousSupplier: "Previous ingredient has no supplier",
    noIngredientsGoBack: "Go back to Step 4 to add ingredients to your components first",
    supplierEmailRequired: "Supplier email is required",

    // Bulk selection
    select: "Select",
    deselectAll: "Deselect All",
    selectedCount: "{count} selected",
    applyToSelected: "Apply to selected",
    setSupplier: "Set Supplier",
    removeSupplier: "Remove Supplier",
    assignUnit: "Assign Unit",
    bulkSupplierSet: "Supplier set for {count} ingredient(s)",
    bulkSupplierRemoved: "Supplier removed from {count} ingredient(s)",
    bulkUnitSet: "Unit set for {count} ingredient(s)",

    // Supplier warnings
    missingSupplierWarning: "{count} ingredient(s) missing supplier",

    // Units
    kg: "kg",
    liter: "l",
    piece: "pcs",
    box: "box",
    package: "package",
    custom: "custom",
    unit: "Unit",
    g: "g",
    ml: "ml",
    st: "st",

    // Completion
    finish: "Finish",
    menuConfigured: "Your menu has been configured successfully.",
    returnToHomepage: "Return to homepage",

    // MenuPreview
    backToEditor: "Back to Editor",
    menuPreview: "Menu Preview",
    kitchenArea: "Kitchen Area",
    components: "Components",
    suppliers: "Suppliers",
    emptyMenuMessage: "Your menu is empty. Add categories and dishes to see a preview.",

    // Menu validation
    incompleteMenuTitle: "Incomplete Menu Configuration",
    incompleteMenuDesc: "Please fix the following issues before finishing:",
    categoryNoDishes: "Category \"{name}\" has no dishes",
    dishNoComponents: "Dish \"{name}\" has no components",
    componentNoIngredients: "Component \"{name}\" has no ingredients",
    ingredientNoSupplier: "Ingredient \"{name}\" has no supplier assigned",
    ingredientNoUnit: "Ingredient \"{name}\" has no unit selected",

    // Menu Identity / Reset
    menuIdentity: "Menu Identity",
    menuNameLabel: "Menu Name",
    menuNamePlaceholder: "e.g. VT 2026, Summer 2026",
    fullReset: "Full Reset",
    fullResetDesc: "This will delete ALL menu data for this restaurant: categories, dishes, components, ingredients, suppliers, and kitchen stations.",
    confirmReset: "Are you sure? This cannot be undone.",
    resetComplete: "Menu data has been reset",
    resetButton: "Reset Menu",

    // Dashboard
    dashboardTitle: "Menu Configurator",
    dashboardInfo: "The configurator guides you through categories, dishes, components, ingredients and suppliers step by step.",
    dashboardLanguageNote: "Changing the language only changes the interface instructions — not your menu content. Write ingredients and components in the language your menu will be used in.",
    editMenu: "Edit Menu",
    createNewMenu: "Create New Menu",
    activeMenu: "Active Menu",
    noActiveMenu: "No active menu. Create one to get started.",
    menuCreated: "Menu created",
    createMenu: "Create",
    menuName: "Menu Name",
    activateMenu: "Activate",
    deactivateMenu: "Deactivate",
    menusManagement: "Menus",
    notesPlaceholder: "Optional notes e.g. custom unit",

    // Comment management
    deleteComment: "Delete comment",
    deleteCommentConfirm: "This action cannot be undone. The comment will be permanently deleted.",
    commentDeleted: "Comment deleted",

    // Fallback
    addIngredientFirst: "Add an ingredient first",
    makeOrderable: "Make orderable",
    makeOrderableSuccess: "Ingredient created and linked",
    alreadyOrderable: "Already orderable",

    // Sorting / grouping
    unassignedStation: "Unassigned",
    sortedAZ: "A–Z",

    // Common
    noItems: "No items yet",
  },

  sv: {
    // Wizard (onboarding)
    restaurantSetup: "Restaurangkonfiguration",
    setupDescription: "Låt oss organisera ditt kök — det tar bara några minuter.",
    stepOf: "Steg {current} av {total}",
    back: "Tillbaka",
    next: "Nästa",
    completeSetup: "Slutför",
    startOver: "Börja om",
    allSet: "Klart!",
    allSetDescription: "Din köksstruktur, meny och leverantörsinformation har sparats. Vi använder detta för att konfigurera din arbetsyta.",
    onboardingComplete: "Konfiguration klar!",
    onboardingCompleteDesc: "Din köksstruktur har sparats.",

    // Step labels (onboarding)
    stepLabels: ["Kökszoner", "Rätter", "Komponenter", "Ingredienser", "Enheter", "Leverantörer", "Övrigt"],

    // Kitchen Areas (onboarding)
    kitchenAreasTitle: "Vilka zoner har ditt kök?",
    kitchenAreasDesc: "Tänk på de olika stationerna där mat tillagas — till exempel Varmkök, Kallkök, Grill, Konditori eller Bar.",
    kitchenAreaPlaceholder: "t.ex. Varmkök",
    addArea: "Lägg till zon",

    // Dishes (onboarding)
    dishesTitle: "Vilka rätter tillagas i varje zon?",
    dishesDesc: "Lägg till rätterna som hör till varje kökszon.",
    addDishTo: "Lägg till en rätt i {name}…",
    addDish: "Lägg till rätt",

    // Components (onboarding)
    componentsTitle: "Vad ingår i varje rätt?",
    componentsDesc: "Lägg till komponenterna som utgör varje rätt — till exempel såser, tillbehör eller protein.",
    componentPlaceholder: "t.ex. Sås, Tillbehör, Protein…",
    addComponent: "Lägg till komponent",

    // Ingredients (onboarding)
    ingredientsTitle: "Vilka ingredienser ingår i varje komponent?",
    ingredientsDesc: "Om en komponent används i flera rätter behöver du bara lista dess ingredienser en gång.",
    ingredientPlaceholder: "t.ex. Olja, Vitlök, Salt…",
    addIngredient: "Lägg till ingrediens",

    // Units (onboarding)
    unitsTitle: "Vilka enheter beställer ni i?",
    unitsDesc: "Välj de enheter ni använder vid beställning av ingredienser, eller lägg till egna.",
    tapToAdd: "Tryck för att lägga till vanliga enheter:",
    customUnitPlaceholder: "Lägg till en egen enhet…",
    addUnit: "Lägg till enhet",

    // Suppliers (onboarding)
    suppliersTitle: "Vilka är era leverantörer?",
    suppliersDesc: "Lägg till leverantörerna ni beställer ingredienser från.",
    supplierNamePlaceholder: "Leverantörsnamn",
    supplierEmailPlaceholder: "E-postadress (valfritt)",
    addSupplier: "Lägg till leverantör",

    // Final (onboarding)
    finalTitle: "Något annat vi bör veta?",
    finalDesc: "Detta är valfritt — dela gärna med dig av extra detaljer om ert kök, meny eller arbetssätt.",
    finalPlaceholder: "t.ex. Vi byter meny efter säsong, vi har gemensamma förberedelseytor, vi behöver glutenfria alternativ…",

    // ── Menu Editor ──
    createYourMenu: "Skapa din meny",
    menuStepLabels: ["Kategorier", "Rätter", "Komponenter", "Ingredienser", "Leverantörer"],
    preview: "Förhandsgranska",
    logOut: "Logga ut",
    save: "Spara",
    saved: "✓ Sparat",
    publish: "Publicera",
    previewButton: "Förhandsgranskning",

    // Kitchen stations
    cold_kitchen: "Kallkök",
    hot_kitchen: "Varmkök",

    // StepCategories
    menuCategories: "Menykategorier",
    categoriesHelperText: "Lägg till kategorier som Förrätter, Huvudrätter, Desserter",
    addCategory: "Lägg till kategori",
    noCategoriesYet: "Inga kategorier ännu",
    noCategoriesHint: "Börja med att lägga till din första menykategori ovan",
    categoryAdded: "Kategori tillagd och sparad",
    categoryRemoved: "Kategori borttagen",
    categoryRenamed: "Kategori omdöpt",
    categoryPlaceholder: "t.ex. Huvudrätter",

    // StepDishes
    yourDishes: "Dina rätter",
    dishesHelperText: "Lägg till rätter i varje kategori och tilldela en köksstation",
    addDishButton: "Lägg till rätt",
    kitchenStation: "Köksstation",
    selectStation: "Välj station",
    customStation: "Anpassad…",
    typeCustomStation: "Skriv namn på anpassad station",
    dishName: "Rättens namn",
    noDishesInCategory: "Inga rätter i denna kategori ännu",
    noCategoriesGoBack: "Gå tillbaka till steg 1 för att lägga till kategorier först",
    dishAdded: "Rätt tillagd och sparad",
    dishRemoved: "Rätt borttagen",
    cancel: "Avbryt",
    addDishTo2: "Lägg till rätt i {name}",
    kitchen: "Kök",

    // StepComponents
    dishComponents: "Rättkomponenter",
    componentsHelperText: "Dela upp varje rätt i dess beståndsdelar — komponenter kan återanvändas mellan rätter",
    addComponentButton: "Lägg till komponent",
    newComponentName: "Nytt komponentnamn...",
    orSelectExisting: "Eller välj befintlig:",
    searchComponents: "Sök komponenter...",
    alreadyAdded: "redan tillagd",
    done: "Klar",
    noComponentsYet: "Inga komponenter ännu",
    noComponentsHint: "Gå tillbaka till steg 2 för att lägga till rätter först",
    noDishesGoBack: "Gå tillbaka till steg 2 för att lägga till rätter först",
    componentAdded: "Komponent tillagd och sparad",
    componentCreated: "Komponent skapad och sparad",
    componentRemoved: "Komponent borttagen från rätt",
    failedRemoveComponent: "Kunde inte ta bort komponent från rätt",
    addComponentTo: "Lägg till komponent i {name}",

    // StepIngredients
    ingredientsTitleEditor: "Ingredienser",
    ingredientsHelperText: "Definiera vad som ingår i varje komponent",
    addIngredientPlaceholder: "Lägg till ingrediens...",
    add: "Lägg till",
    quickAddPlaceholder: "Snabblägg: klistra in flera ingredienser separerade med kommatecken eller radbrytningar (t.ex. salt, olivolja, vitlök)",
    quickAddAll: "Snabblägg alla",
    ingredientAdded: "Ingrediens tillagd och sparad",
    ingredientsAdded: "{count} ingrediens(er) tillagda och sparade",
    ingredientRemoved: "Ingrediens borttagen",
    noComponentsGoBack: "Gå tillbaka till steg 3 för att lägga till komponenter först",
    usedIn: "Används i",
    noIngredientsAddedYet: "Inga ingredienser tillagda ännu",
    changeStation: "Ändra",

    // StepSuppliers
    suppliersTitleEditor: "Leverantörer",
    suppliersHelperText: "Koppla leverantörer till varje ingrediens",
    newSupplier: "Ny leverantör",
    selectSupplier: "Välj leverantör",
    copyPrevious: "Kopiera föregående",
    notes: "Anteckningar",
    optionalNotes: "Valfria anteckningar",
    supplierName: "Leverantörsnamn *",
    emailRequired: "E-post *",
    emailOptional: "E-post (valfritt)",
    createSupplierButton: "Skapa leverantör",
    supplierCreated: "Leverantör skapad och sparad",
    supplierLinked: "Leverantör kopplad och sparad",
    noPreviousSupplier: "Föregående ingrediens har ingen leverantör",
    noIngredientsGoBack: "Gå tillbaka till steg 4 för att lägga till ingredienser först",
    supplierEmailRequired: "Leverantörens e-post krävs",

    // Bulk selection
    select: "Välj",
    deselectAll: "Avmarkera alla",
    selectedCount: "{count} valda",
    applyToSelected: "Tillämpa på valda",
    setSupplier: "Sätt leverantör",
    removeSupplier: "Ta bort leverantör",
    assignUnit: "Tilldela enhet",
    bulkSupplierSet: "Leverantör satt för {count} ingrediens(er)",
    bulkSupplierRemoved: "Leverantör borttagen från {count} ingrediens(er)",
    bulkUnitSet: "Enhet satt för {count} ingrediens(er)",

    // Supplier warnings
    missingSupplierWarning: "{count} ingrediens(er) saknar leverantör",

    // Units
    kg: "kg",
    liter: "l",
    piece: "st",
    box: "låda",
    package: "förp",
    custom: "anpassad",
    unit: "Enhet",
    g: "g",
    ml: "ml",
    st: "st",

    // Completion
    finish: "Slutför",
    menuConfigured: "Din meny har konfigurerats framgångsrikt.",
    returnToHomepage: "Tillbaka till startsidan",

    // MenuPreview
    backToEditor: "Tillbaka till redigeraren",
    menuPreview: "Förhandsgranskning av meny",
    kitchenArea: "Kökszon",
    components: "Komponenter",
    suppliers: "Leverantörer",
    emptyMenuMessage: "Din meny är tom. Lägg till kategorier och rätter för att se en förhandsgranskning.",

    // Menu validation
    incompleteMenuTitle: "Ofullständig menykonfiguration",
    incompleteMenuDesc: "Åtgärda följande problem innan du slutför:",
    categoryNoDishes: "Kategorin \"{name}\" har inga rätter",
    dishNoComponents: "Rätten \"{name}\" har inga komponenter",
    componentNoIngredients: "Komponenten \"{name}\" har inga ingredienser",
    ingredientNoSupplier: "Ingrediensen \"{name}\" har ingen leverantör",
    ingredientNoUnit: "Ingrediensen \"{name}\" har ingen enhet vald",

    // Menu Identity / Reset
    menuIdentity: "Menu Identity",
    menuNameLabel: "Menynamn",
    menuNamePlaceholder: "t.ex. VT 2026, Sommar 2026",
    fullReset: "Fullständig återställning",
    fullResetDesc: "Detta raderar ALL menydata för denna restaurang: kategorier, rätter, komponenter, ingredienser, leverantörer och köksstationer.",
    confirmReset: "Är du säker? Detta kan inte ångras.",
    resetComplete: "Menydata har återställts",
    resetButton: "Återställ meny",

    // Dashboard
    dashboardTitle: "Menykonfigurator",
    dashboardInfo: "Konfiguratorn guidar dig genom kategorier, rätter, komponenter, ingredienser och leverantörer steg för steg.",
    dashboardLanguageNote: "Att byta språk ändrar bara instruktionerna i gränssnittet — inte din meny. Skriv ingredienser och komponenter på det språk menyn ska användas på.",
    editMenu: "Redigera meny",
    createNewMenu: "Skapa ny meny",
    activeMenu: "Aktiv meny",
    noActiveMenu: "Ingen aktiv meny. Skapa en för att komma igång.",
    menuCreated: "Meny skapad",
    createMenu: "Skapa",
    menuName: "Menynamn",
    activateMenu: "Aktivera",
    deactivateMenu: "Avaktivera",
    menusManagement: "Menyer",
    notesPlaceholder: "Valfria anteckningar t.ex. anpassad enhet",

    // Comment management
    deleteComment: "Radera kommentar",
    deleteCommentConfirm: "Denna åtgärd kan inte ångras. Kommentaren raderas permanent.",
    commentDeleted: "Kommentar raderad",

    // Fallback
    addIngredientFirst: "Lägg till en ingrediens först",
    makeOrderable: "Gör beställningsbar",
    makeOrderableSuccess: "Ingrediens skapad och kopplad",
    alreadyOrderable: "Finns redan som beställningsvara",

    // Sorting / grouping
    unassignedStation: "Ej tilldelad",
    sortedAZ: "A–Ö",

    // Common
    noItems: "Inga poster ännu",
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
